import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import '@effectivastudio/lit-components/components/icon/element.js';

/**
 * Navigation control
 *
 * @prop href - URL link
 * @prop name - Item title
 * @prop info - Item info in the right corner (optional)
 * @prop hint - Item hint below the title (optional)
 * @prop active - false (optional)
 * @prop action - link data-remote action (optional)
 */
export default class ListItem6 extends ApplicationElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    href: { type: String },
    name: { type: String },
    info: { type: String },
    hint: { type: String },
    active: { type: Boolean },
    action: { type: String },
  };

  /** @internal */
  get classes() {
    return {
      active: this.activateByCurrentLink(),
    };
  }

  renderInfo() {
    return html`<span class="info">${this.info}</span>`;
  }

  renderHint() {
    return html`<div class="hint">${this.hint}</div>`;
  }

  render() {
    return html`
      <a
        href="${this.href}"
        class=${classMap(this.classes)}
        data-turbolinks-action=${ifDefined(this.action)}>
        <div class="content">
          <h4 class="title">${this.name}</h4>
          ${this.info && this.renderInfo()}
          <ef-icon name="chevron-right"></ef-icon>
        </div>
        ${this.hint && this.renderHint()}
      </a>
    `;
  }
}

customElements.get('bu-list-item-6') ||
  customElements.define('bu-list-item-6', ListItem6);
